import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { CustomPropsRecord } from "schemas/component";
import type { ComponentConfig } from "../../components";

import { convertToLegacyProps } from "../../../shared/utils/props";

function getConfigurableProps(): CustomPropsRecord {
  return {
    _product: {
      name: "Product",
      type: "product",
      description: "Shopify product which should be displayed.",
      defaultValue: null,
    },
    _css: {
      type: "cssCodeEditor",
      name: "Custom Loox CSS",
      description:
        "Provide custom CSS for styling the Loox widget. See the Loox documentation for more info.",
      defaultValue: null,
    },
    _showAllRatings: {
      type: "boolean",
      name: "Show ratings from all products",
      description:
        "Enabling this will show product rating data from all products instead of a single product.",
      defaultValue: false,
    },
    _allowEmptyStars: {
      type: "boolean",
      name: "Show with no reviews",
      description:
        "Enabling this will make sure the widget renders even when there are no reviews for the product.",
      defaultValue: false,
    },
  };
}

const styleElements = {
  root: {},
} as const satisfies StyleElements;

const config = {
  renderData: {
    newInstancesUseNumbering: false,
    customProps: convertToLegacyProps(getConfigurableProps()),
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: false,
    canContainChildren: false,
    styleElements,
  },
} satisfies ComponentConfig;

export default config;
